import { render } from "./OptionYesNo.vue?vue&type=template&id=15424a12"
import script from "./OptionYesNo.vue?vue&type=script&lang=js"
export * from "./OptionYesNo.vue?vue&type=script&lang=js"

import exportComponent from "/builds/sgumanea/ciena/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__